/* eslint-disable no-nested-ternary */
import React from 'react'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { formatCurrency } from '../../utils/helpers/common'
import DeleteButton from '../common/buttons/DeleteButton'
import DataTableComp from '../common/data-table/DataTableComp'
import { DataTableFun } from '../../utils/helpers/dataTableFun'

const DataTableAccountProjects = ({
  data,
  loading = false,
  showHeaders = true,
  showWhenNoData = false,
  footerGroup,
  handleDelete,
}) => {
  const { formatMessage: msg } = useIntl()

  const columns = () => {
    const commonColumns = [
      <Column
        field="projectCode"
        sortable={data?.length > 1}
        style={{ width: '60%' }}
        body={(rowData) => String(rowData.projectCode || '')}
        header={showHeaders && msg({ id: 'project' })}
      />,
      <Column
        field="credit"
        sortable={data?.length > 1}
        className="text-monospace"
        style={{ width: '20%' }}
        align="right"
        body={(rowData) => formatCurrency(rowData.credit)}
        header={showHeaders && msg({ id: 'credit' })}
      />,
      <Column
        field="debit"
        sortable={data?.length > 1}
        className="text-monospace"
        style={{ width: '20%' }}
        align="right"
        body={(rowData) => formatCurrency(rowData.debit)}
        header={showHeaders && msg({ id: 'debit' })}
      />,
    ]
    return [...commonColumns]
  }

  return (data && data.length > 0) || showWhenNoData ? (
    <DataTableComp
      disableAutoheight
      style={{ width: '100%' }}
      tableOptions={{
        showHeaders,
        value: data,
        responsiveLayout: 'scroll',
        scrollable: true,
        scrollHeight: 500,
        // scrollHeight: DataTableFun.responsiveHeight(),
        footerColumnGroup: footerGroup || undefined,
      }}
      autoColumnKey
      columns={columns()}
    />
  ) : null
}

export default DataTableAccountProjects
